import PageTitle from "../../../layouts/PageTitle";
import React, { useState, useRef, Fragment, useEffect, useCallback  } from "react";
import {
   getCroppedImg,
   GetServices,
   UpdateSiteSection,
   GetBarbers,
   DisableSiteSection,
} from './Requests';
import './SitePages.css'
import {PulseLoader } from "react-spinners";
import Select from "react-select";
import { ToastContainer} from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  notifyError,
  notifySuccess
} from '../Response/ResposeHandler'

const SiteSections = (props) => {
    const [aboutUsPage, setAboutUsPage] = useState(props.site.aboutUsPageEnabled)
    const [aboutUsPageTitle, setAboutUsPageTitle] = useState(props.site.aboutUsPageTitle)
    const [aboutUsPageDescription, setAboutUsPageDescription] = useState(props.site.aboutUsDescription)
    const [staffPage, setStaffPage] = useState(props.site.staffPageEnabled)
    const [staffPageTitle, setStaffPageTitle] = useState(props.site.staffPageTitle)
    const [staffPageDescription, setStaffPageDescription] = useState(props.site.staffDescription)
    const [servicePage, setServicePage] = useState(props.site.servicePageEnabled)
    const [servicePageTitle, setServicePageTitle] = useState(props.site.servicePageTitle)
    const [servicePageDescription, setServicePageDescription] = useState(props.site.serviceDescription)
    const [noticePage, setNoticePage] = useState(props.site.siteNoticeEnabled)
    const [noticePageTitle, setNoticePageTitle] = useState(props.site.siteNoticeTitle)
    const [noticePageDescription, setNoticePageDescription] = useState(props.site.siteNoticeDescription)
    let errorsAboutObj = { title: '', description: ''};
    const [aboutErrors, setAboutErrors] = useState(errorsAboutObj);
    let errorsNoticeObj = { title: '', description: ''};
    const [noticeErrors, setNoticeErrors] = useState(errorsNoticeObj);
    let errorsServiceObj = { title: '', description: ''};
    const [serviceErrors, setServiceErrors] = useState(errorsServiceObj);
    let errorsStaffObj = { title: '', description: ''};
    const [staffErrors, setStaffErrors] = useState(errorsStaffObj);
    const [services, setServices] = useState([])
    const [staff, setStaff] = useState([])
    const [siteServcies, setSiteServices] = useState([])
    const [siteStaff, setSiteStaff] = useState([])
    const [aboutSaveButtonLoading, setAboutSaveButtonLoading] = useState(false)
    const [staffSaveButtonLoading, setStaffSaveButtonLoading] = useState(false)
    const [serviceSaveButtonLoading, setServiceSaveButtonLoading] = useState(false)
    const [noticeSaveButtonLoading, setNoticeSaveButtonLoading] = useState(false)
    const [show, setShow] = useState(false)

    useEffect(() => {
        GetServicesWrapper()
    }, []);

    const ClearIndicator = (props) => {
    const {
    getStyles,
    innerProps: { ref, ...restInnerProps },
    } = props;
    return (
        <div
            {...restInnerProps}
            ref={ref}
            style={getStyles("clearIndicator", props)}
        >
            <div style={{ padding: "0px 5px" }}>Clear</div>
        </div>
    );
};

const ClearIndicatorStyles = (base, state) => ({
    ...base,
    cursor: "pointer",
    color: state.isFocused ? "#525252" : "#7e7e7e",
});

function GetServicesWrapper() {
GetServices().then((res) => {
    var tempVar = []
    res.data.map((item, index) => {
        var obj = { value: item.serviceId, label: item.name, isDisabled: item.status === 1 ? false : true }
        tempVar.push(obj)
    })
    setServices(tempVar)
    const idset = new Set(props.site.servicesIds.map(item => item))
    const common = tempVar.filter(item => idset.has(item.value))
    setSiteServices(common)
}).catch((error) => {
}).finally((f) =>{
    GetStaffWrapper()
})
}

function GetStaffWrapper() {
GetBarbers().then((res) => {
    var tempVar = []
    res.data.map((item, index) => {
        var obj = { value: item.barberId, label: item.name, isDisabled: item.status === 1 ? false : true }
        tempVar.push(obj)
    })
    setStaff(tempVar)
    const idset = new Set(props.site.staffIds.map(item => item))
    const common = tempVar.filter(item => idset.has(item.value))
    setSiteStaff(common)
}).catch((error) => {
}).finally((f) => {
    setShow(true)
})
}

    function PageStatusHandler(e) {
        if (e.target.id === "about")
            {
                setAboutUsPage(e.target.checked)
                if (!e.target.checked)
                {
                    setAboutErrors({ title: '', description: ''})
                    DisableSection(e.target.id)
                }
            }
        if (e.target.id === "staff")
            {
                setStaffPage(e.target.checked)
                if (!e.target.checked)
                {
                    setStaffErrors({ title: '', description: ''})
                    DisableSection(e.target.id)
                }
            }
        if (e.target.id === "service")
            {
                setServicePage(e.target.checked)
                if (!e.target.checked)
                {
                    setServiceErrors({ title: '', description: ''})
                    DisableSection(e.target.id)
                }
            }
        if (e.target.id === "notice")
            {
                setNoticePage(e.target.checked)
                if (!e.target.checked)
                {
                    setNoticeErrors({ title: '', description: ''})
                    DisableSection(e.target.id)
                }
            }
        }

function SubmitAboutUs()
{
    let aboutError = false;
    const errorAboutObj = { ...errorsAboutObj };

    if (!aboutUsPageTitle)
    {
        errorAboutObj.title = "Please enter a title for this section"
        aboutError = true
    }
    if (!aboutUsPageDescription)
    {
        errorAboutObj.description = "Please enter a description for this section"
        aboutError = true
    }
    setAboutErrors(errorAboutObj)

    if (aboutError === true)
    {
        notifyError("Invalid details provided")
    }
    else{
        setAboutSaveButtonLoading(true)
        UpdateSiteSection(aboutUsPageTitle, aboutUsPageDescription, null, "about", aboutUsPage).then((res) => {
            notifySuccess("Section Saved")
        }).catch((error) => {
            notifyError("There was an issue saving this site section, please try again or contact support.")
        }).finally((f) => {
            props.getSite()
            setAboutSaveButtonLoading(false)
        })
    }
}

function SubmitNotice()
{
    let noticeError = false;
    const errorNoticeObj = { ...errorsNoticeObj };

    if (!noticePageTitle)
    {
        errorNoticeObj.title = "Please enter a title for this section"
        noticeError = true
    }
    if (!noticePageDescription)
    {
        errorNoticeObj.description = "Please enter a description for this section"
        noticeError = true
    }
    setNoticeErrors(errorNoticeObj)

    if (noticeError === true)
    {
        notifyError("Invalid details provided")
    }
    else{
        setNoticeSaveButtonLoading(true)
        UpdateSiteSection(noticePageTitle, noticePageDescription, null, "notice", noticePage).then((res) => {
            notifySuccess("Section Saved")
        }).catch((error) => {
            notifyError("There was an issue saving this site section, please try again or contact support.")
        }).finally((f) => {
            props.getSite()
            setNoticeSaveButtonLoading(false)
        })
    }
}

function SubmitServiceSection()
{
    console.log(siteServcies.map(w => w.value))
    let serviceError = false;
    const errorServiceObj = { ...errorsServiceObj };

    if (!servicePageTitle)
    {
        errorServiceObj.title = "Please enter a title for this section"
        serviceError = true
    }
    // if (!servicePageDescription)
    // {
    //     errorServiceObj.description = "Please enter a description for this section"
    //     serviceError = true
    // }
    setServiceErrors(errorServiceObj)
    if (serviceError)
    {
        notifyError("Invalid details provided")
    }
    else{
        setServiceSaveButtonLoading(true)
        UpdateSiteSection(servicePageTitle, servicePageDescription, siteServcies.map(w => w.value), "service", servicePage).then((res) => {
            notifySuccess("Section Saved")
        }).catch((error) => {
            notifyError("There was an issue saving this site section, please try again or contact support.")
        }).finally((f) => {
            props.getSite()
            setServiceSaveButtonLoading(false)
        })
    }
}
   
function SubmitStaffSection()
{
    let staffError = false;
    const errorStaffeObj = { ...errorsStaffObj };

    if (!staffPageTitle)
    {
        errorStaffeObj.title = "Please enter a title for this section"
        staffError = true
    }
    // if (!staffPageDescription)
    // {
    //     errorStaffeObj.description = "Please enter a description for this section"
    //     staffError = true
    // }
    setStaffErrors(errorStaffeObj)
    if (staffError)
    {
        notifyError("Invalid details provided")
    }
    else{
        setStaffSaveButtonLoading(true)
        UpdateSiteSection(staffPageTitle, staffPageDescription, siteStaff.map(w => w.value), "staff", staffPage).then((res) => {
            notifySuccess("Section Saved")
        }).catch((error) => {
            notifyError("There was an issue saving this site section, please try again or contact support.")
        }).finally((f) => {
            props.getSite()
            setStaffSaveButtonLoading(false)
        })
    }
}

function DisableSection(sectionName)
{
    DisableSiteSection(sectionName).then((res) => {
            notifySuccess("Section disabled, this section will not show up on your site.")
        }).catch((error) => {
            notifyError("There was an issue disabling this site section please try again or contact support.")
        }).finally((f) => {
            props.getSite()
        })
}

    return (
    <div>
        <ToastContainer />
        <div style={{marginTop:"2rem"}} className="card">
            <div style={{padding:"0 2rem 1rem 2rem"}} className={`card-body test ${aboutUsPage ? 'expanded' : ''}`}>
                <div className="toggle-page-status-container">
                    <h3 style={{marginTop:"2rem"}}>About us</h3>
                    <div className="page-enable-switch-wrapper">
                        <input
                            className="toggle-switch"
                            type="checkbox"
                            defaultChecked={false}
                            checked={aboutUsPage}
                            id="about"
                            onChange={(e) => {PageStatusHandler(e)}}
                        />
                        <label htmlFor='about' className="switch-label"/>
                    </div>
                </div>
                {aboutUsPage
                ?
                <div>
                    <label style={{marginTop:"2rem"}} htmlFor="site-title">Section Title</label>
                    <input maxLength={30} onChange={(e) => {setAboutUsPageTitle(e.target.value)}} value={aboutUsPageTitle} type="text" id="about-us-title" placeholder="About Us"/>
                    {aboutErrors.title && <div className="text-danger fs-12">{aboutErrors.title}</div>}
                    <label>Section Descritpion</label>
                    <textarea
                        onChange={(e) => {setAboutUsPageDescription(e.target.value)}}
                        maxLength={300}
                        rows="4"
                        type="textarea"
                        placeholder="Description about your business"
                        value={aboutUsPageDescription}
                        />
                        {aboutErrors.description && <div className="text-danger fs-12">{aboutErrors.description}</div>}
                            <button disabled={aboutSaveButtonLoading} onClick={SubmitAboutUs} style={{marginTop:0, marginTop:"2rem"}} className='save-button button'>
                                {!aboutSaveButtonLoading ?
                                "Save":
                                <PulseLoader 
                                    color={'#eee'}
                                    loading={aboutSaveButtonLoading}
                                    size={10}
                                    aria-label="Loading Spinner"
                                    data-testid="loader"
                                />
                                }
                            </button>
                </div>
                :
                <></>
                }
            </div>
        </div>
        <div style={{marginTop:"2rem"}} className="card">
            <div style={{padding:"0 2rem 1rem 2rem"}} className={`card-body test ${servicePage ? 'expanded' : ''}`}>
                <div className="toggle-page-status-container">
                    <h3 style={{marginTop:"2rem"}}>Service Section</h3>
                    <div className="page-enable-switch-wrapper">
                        <input
                            className="toggle-switch"
                            type="checkbox"
                            defaultChecked={false}
                            checked={servicePage}
                            id="service"
                            onChange={(e) => {PageStatusHandler(e)}}
                        />
                        <label htmlFor='service' className="switch-label"/>
                    </div>
                </div>
                {servicePage
                ?
                <div>
                    <label htmlFor="site-title">Select the service you would like to appear on your site</label>
                    {show ?
                    <Select
                        closeMenuOnSelect={false}
                        components={{ ClearIndicator }}
                        styles={{ clearIndicator: ClearIndicatorStyles }}
                        isMulti
                        style={{height:'none'}}
                        // value={siteServcies}
                        defaultValue={siteServcies}
                        options={services}
                        onChange={(e) => setSiteServices(e)}
                    />
                    :
                    <>
                    </>
}
                    <label style={{marginTop:"2rem"}} htmlFor="site-title">Section Title</label>
                    <input maxLength={30} onChange={(e) => {setServicePageTitle(e.target.value)}} value={servicePageTitle} type="text" id="staff-title" placeholder="Services that we offer"/>
                    {serviceErrors.title && <div className="text-danger fs-12">{serviceErrors.title}</div>}

                    <label>Section Descritpion</label>
                    <textarea
                        onChange={(e) => {setServicePageDescription(e.target.value)}}
                        maxLength={300}
                        rows="4"
                        type="textarea"
                        placeholder="Take a look at the wide range of services that we offer"
                        value={servicePageDescription}
                        />
                        {serviceErrors.description && <div className="text-danger fs-12">{serviceErrors.description}</div>}
                        <button disabled={serviceSaveButtonLoading} onClick={SubmitServiceSection} style={{marginTop:0, marginTop:"2rem"}} className='save-button button'>
                            {!serviceSaveButtonLoading ?
                            "Save":
                            <PulseLoader 
                                color={'#eee'}
                                loading={serviceSaveButtonLoading}
                                size={10}
                                aria-label="Loading Spinner"
                                data-testid="loader"
                            />
                            }
                        </button>
                </div>
                :
                <></>
                }

            </div>
        </div>
        <div style={{marginTop:"2rem"}} className="card">
            <div style={{padding:"0 2rem 1rem 2rem"}} className={`card-body test ${staffPage ? 'expanded' : ''}`}>
                <div className="toggle-page-status-container">
                    <h3 style={{marginTop:"2rem"}}>Staff Section</h3>
                    <div className="page-enable-switch-wrapper">
                        <input
                            className="toggle-switch"
                            type="checkbox"
                            defaultChecked={false}
                            checked={staffPage}
                            id="staff"
                            onChange={(e) => {PageStatusHandler(e)}}
                        />
                        <label htmlFor='staff' className="switch-label"/>
                    </div>
                </div>
                {staffPage
                ?
                <div>
                    <label htmlFor="site-title">Select the staff you would like to appear on your site</label>
                    {show ?
                    <Select
                        closeMenuOnSelect={false}
                        components={{ ClearIndicator }}
                        styles={{ clearIndicator: ClearIndicatorStyles }}
                        isMulti
                        style={{height:'none'}}
                        defaultValue={siteStaff}
                        options={staff}
                        onChange={(e) => setSiteStaff(e)}
                    />
                    :
                    <></>
                    }
                    <label style={{marginTop:"2rem"}} htmlFor="site-title">Section Title</label>
                    <input maxLength={30} onChange={(e) => {setStaffPageTitle(e.target.value)}} value={staffPageTitle} type="text" id="staff-title" placeholder="Team Members"/>
                    {staffErrors.title && <div className="text-danger fs-12">{staffErrors.title}</div>}
                    <label>Section Descritpion</label>
                    <textarea
                        onChange={(e) => {setStaffPageDescription(e.target.value)}}
                        maxLength={300}
                        rows="4"
                        type="textarea"
                        placeholder="Meet the team. We are a team of 6 with expertise in all areas."
                        value={staffPageDescription}
                        />
                    {staffErrors.description && <div className="text-danger fs-12">{staffErrors.description}</div>}
                        <button disabled={staffSaveButtonLoading} onClick={SubmitStaffSection} style={{marginTop:0, marginTop:"2rem"}} className='save-button button'>
                            {!staffSaveButtonLoading ?
                            "Save":
                            <PulseLoader 
                                color={'#eee'}
                                loading={staffSaveButtonLoading}
                                size={10}
                                aria-label="Loading Spinner"
                                data-testid="loader"
                            />
                            }
                        </button>
                </div>
                :
                <></>
                }

            </div>
        </div>
        <div style={{marginTop:"2rem"}} className="card">
            <div style={{padding:"0 2rem 1rem 2rem"}} className={`card-body test ${noticePage ? 'expanded' : ''}`}>
                <div className="toggle-page-status-container">
                    <h3 style={{marginTop:"2rem"}}>Site Notice</h3>
                    <div className="page-enable-switch-wrapper">
                        <input
                            className="toggle-switch"
                            type="checkbox"
                            defaultChecked={false}
                            checked={noticePage}
                            id="notice"
                            onChange={(e) => {PageStatusHandler(e)}}
                        />
                        <label htmlFor='notice' className="switch-label"/>
                    </div>
                </div>
                {noticePage
                ?
                <div>
                    <label style={{marginTop:"2rem"}} htmlFor="site-title"> Notice Title</label>
                    <input maxLength={30} onChange={(e) => {setNoticePageTitle(e.target.value)}} value={noticePageTitle} type="text" id="staff-title" placeholder="Customer Notice"/>
                        {noticeErrors.title && <div className="text-danger fs-12">{noticeErrors.title}</div>}

                    <label>Notice Descritpion</label>
                    <textarea
                        onChange={(e) => {setNoticePageDescription(e.target.value)}}
                        maxLength={300}
                        rows="4"
                        type="textarea"
                        placeholder="We are going to be closed from the 05/05 - 10/05 due to shop renovations. Apologies for any inconveniences."
                        value={noticePageDescription}
                        />
                        {noticeErrors.description && <div className="text-danger fs-12">{noticeErrors.description}</div>}
                            <button disabled={noticeSaveButtonLoading} onClick={SubmitNotice} style={{marginTop:0, marginTop:"2rem"}} className='save-button button'>
                                {!noticeSaveButtonLoading ?
                                "Save":
                                <PulseLoader 
                                    color={'#eee'}
                                    loading={noticeSaveButtonLoading}
                                    size={10}
                                    aria-label="Loading Spinner"
                                    data-testid="loader"
                                />
                                }
                            </button>
                </div>
                :
                <></>
                }

            </div>
        </div>
    </div>
    );
}

export default SiteSections;